// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disabled-input-group[data-v-2fc66acc]{cursor:not-allowed}.disabled-input-group .input-addon[data-v-2fc66acc]{background:#999!important}.disabled-input-group .total-label[data-v-2fc66acc]{cursor:not-allowed}.total-label[data-v-2fc66acc]{white-space:nowrap;padding:0 10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
